import { useCallback, useRef, useState } from "react";
import { ResizeObserver } from "@juggle/resize-observer";

interface UseContainerSizeReturn {
  containerHeight: number;
  containerRef: (node: HTMLDivElement | null) => void;
  containerWidth: number;
}

export const useContainerSize = (): UseContainerSizeReturn => {
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  const containerRef = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (!node) return;

    setContainerWidth(node.getBoundingClientRect().width);
    setContainerHeight(node.getBoundingClientRect().height);

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry && entry.contentRect) {
        setContainerWidth(entry.contentRect.width);
        setContainerHeight(entry.contentRect.height);
      }
    });
    observer.observe(node);
    observerRef.current = observer;
  }, []);

  return {
    containerHeight,
    containerRef,
    containerWidth,
  };
};
